import { Divider, List, ListItem, ListItemProps, Theme, Button, colors, ButtonProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import clsx from 'clsx';
import CustomRouterLink from './CustomRouterLink';
import { NavLinkProps } from 'react-router-dom';

const toolbarHeight = 68;

export const useSidebarListStyles = makeStyles((theme: Theme) => ({
  toolbar: {
    height: 68,
    padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`
  },
  list: {
    height: `calc(100% - ${toolbarHeight+1}px)`,
    overflowY: 'auto',
    paddingBottom: theme.spacing(3)
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  sidebar: {
    flex: '0 0 280px',
    borderRight: `1px solid ${theme.palette.divider}`,
    background: theme.palette.white
  },
  buttonLeaf: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    paddingLeft: theme.spacing(1),
    fontWeight: 500,
    '&.depth-0': {
      fontWeight: 400
    }
  },
  itemActive: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    fontWeight: 500,
  },
}))

const Toolbar = (props: {children: React.ReactNode}) => {
  const classes = useSidebarListStyles();

  return <div className={classes.toolbar}>
    {props.children}
  </div>
}

interface SidebarListProps {
  children: React.ReactNode
  toolbar?: React.ReactNode
}

const SidebarList = ({children, toolbar}: SidebarListProps) => {
  const classes = useSidebarListStyles();

  return <React.Fragment>
    <Toolbar>
      {toolbar}
    </Toolbar>
    <Divider/>
    <List className={classes.list}>
      {children}
    </List>
  </React.Fragment>
}

interface SidebarListItemProps extends ListItemProps {
  active: boolean,
  href: string
}

export const SidebarListItem = (props: SidebarListItemProps) => {
  const {active, href, className, children, button: _, ...rest} = props;
  const classes = useSidebarListStyles();
  
  const CastedButton = Button as React.FC<ButtonProps & NavLinkProps>;

  return <ListItem 
    className={clsx(classes.item, active && classes.itemActive || '', className || '')} 
    component="li"
    disableGutters
    {...rest}
  >
    <CastedButton
      activeClassName={classes.itemActive}
      className={classes.buttonLeaf}
      component={CustomRouterLink}
      exact
      to={href}
    >
      {children}
    </CastedButton>
  </ListItem>
}

export const Sidebar = (props: React.HTMLProps<HTMLDivElement>) => {
  const classes = useSidebarListStyles();
  // eslint-disable-next-line react/prop-types
  const {className, ...rest} = props;

  return <div 
    className={clsx(classes.sidebar, className)} 
    {...rest} />
}

export default SidebarList;